import { render } from "./EditCategory.vue?vue&type=template&id=39684a4a"
import script from "./EditCategory.vue?vue&type=script&lang=js"
export * from "./EditCategory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__